import { styled } from '../../Styles/stitches.config'

export const Wrapper = styled('div', {
    alignItems: 'center',
    display: 'flex',
    gap: '$2',
})

export const FabIcon = styled('div', {
    boxShadow: '$default',
    br: '50%',
    overflow: 'hidden',
    left: '50%',
    position: 'fixed',
    transform: 'translateX(-50%)',
    zIndex: '$fixed',
})

export const StyledAppBar = styled('div', {
    alignItems: 'center',
    bgc: '$neutral100',
    color: '$primary600',
    display: 'flex',
    justifyContent: 'space-between',
    left: 0,
    p: '$3',
    position: 'fixed',
    right: 0,
    transition: '$default',
    zIndex: '$fixed',

    variants: {
        showShadow: {
            false: {
                boxShadow: 'none',
            },
        },
        variant: {
            default: {
                bgc: '$neutral100',
                color: '$primary600',
            },
            primary: {
                bgc: '$primary600',
                color: '$white',
            },
        },
    },
})
